import React, { useState } from 'react';
import * as Checkbox from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

export interface CheckboxProps {
    label?: string,
    contentLabel?: React.ElementType | null,
    onCheckedChange?: Function,
    className?: string,
    checked?: boolean
}

const CheckboxComponent = ({ label = '', contentLabel = null, onCheckedChange, className = '', checked = false }: CheckboxProps) => {
    const [check, setChecked] = useState<boolean>(checked);
    return (
        <form className={className}>
            <div className='flex items-start'>
                <Checkbox.Root
                    className='flex size-[20px] items-center justify-center rounded bg-white data-[state=checked]:bg-greenMain data-[state=checked]:border-0 border-text/50 border-[1px] outline-none'
                    id='c1'
                    onCheckedChange={(e) => {
                        setChecked(e === true);
                        onCheckedChange && onCheckedChange(e);
                    }}
                    checked={check}
                >
                    <Checkbox.Indicator className=''>
                        <Check size={16} className='text-white' />
                    </Checkbox.Indicator>
                </Checkbox.Root>
                <div className='flex items-start pl-[8px] text-text text-[15px]'>
                    {contentLabel ?
                        React.createElement(contentLabel) :
                        (
                            <label
                                htmlFor='c1'
                            >
                                {label}
                            </label>
                        )}
                </div>

            </div>
        </form>
    );
};

export default CheckboxComponent;
